import React, { useEffect, useState } from "react";
import { TreeSelect, ConfigProvider } from "antd";
import ArrowForwardIosRoundedIcon from "@mui/icons-material/ArrowForwardIosRounded";

import { ReactComponent as ArrowDown } from "assets/Svgs/ArrowDown.svg";
import { useBoundStore } from "store/store";
import { InputLabel } from "@mui/material";
import i18n from "i18n/i18n";

const { SHOW_ALL , SHOW_PARENT} = TreeSelect;

function AntDTree(props: any) {
  const lang = useBoundStore((state) => state.lang);

  const [value, setValue] = useState<any>([]);
  const [allState, setAllllState] = useState(
    props.treeData
      ? props.treeData.map((data: any) => {
          return data.value;
        })
      : []
  );

  const onChange = (valuee: any, label: any, extra: any) => {
   
    if (extra.triggerValue === "all") {
      if (extra.checked) {
        setValue(["all", ...allState]);
      } else {
        setValue([]);
      }
      return;
    } else {
      let isAll = valuee.includes("all");
     
      if (isAll) {
        setValue(
          valuee.filter((val: any) => {
            return val !== "all";
          })
        );
      } else {
        if (IsSameArrays(valuee, allState)) {
          setValue(["all", ...valuee]);
        } else {
          setValue(valuee);
        }
      }
    }
  };

  const IsSameArrays = (array1: any, array2: any) => {
    const array2Sorted = array2.slice().sort();
    return (
      array1.length === array2.length &&
      array1
        .slice()
        .sort()
        .every(function (value: any, index: any) {
          return value === array2Sorted[index];
        })
    );
  };

  useEffect(() => {
    props.getTreeValues(value);
  }, [value]);

  useEffect(() => {
    setValue(props.initialValues);
  }, [props.initialValues]);

  const tProps = {
    treeData: [
      {
        title: "all",
        value: "all",
        key: "all",
      },
      ...props.treeData,
    ],
    value: value,
    onChange: onChange,
    treeCheckable: true,
    
    showCheckedStrategy: SHOW_PARENT,
    placeholder: "---Select---",
    className: value.length ? "" : "antTreeSelectError",
    allowClear: true,

    style: {
      width: "100%",
      height: "55px",
      padding: "0px 24px",
    },
    listHeight: 1000,
    treeLine: true,
    maxTagCount: 3,
    maxTagPlaceholder: "+" + (value.length - 3) + " more",
    
  };

  return (
    <ConfigProvider
      theme={{
        components: {
          TreeSelect: {
            colorPrimary: "var(--primary-color)",
            colorPrimaryHover: "var(--primary-color)",
          },
        },
      }}
    >
      <div style={{ position: "relative" }}>
        <div
          className="customMuiLabel MuiFormLabel-root MuiInputLabel-root MuiInputLabel-formControl MuiInputLabel-animated MuiInputLabel-shrink MuiInputLabel-sizeMedium MuiInputLabel-outlined MuiFormLabel-colorPrimary MuiFormLabel-filled MuiInputLabel-root MuiInputLabel-formControl MuiInputLabel-animated MuiInputLabel-shrink MuiInputLabel-sizeMedium MuiInputLabel-outlined css-6m4s60-MuiFormLabel-root-MuiInputLabel-root"
          style={{ marginLeft: "2%" }}
        >
          {i18n(lang).devices}
        </div>
        <TreeSelect
          {...tProps}
          filterTreeNode={(input, treeNode) => {
            const match = treeNode.title
              ?.toLocaleString()
              .toLocaleLowerCase()
              .includes(input?.toLocaleString().toLocaleLowerCase())
              ? true
              : false;
            return match;
          }}
        />
        <div className="svg">
          
        </div>
      </div>
    </ConfigProvider>
  );
}

export default AntDTree;
